var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-chart-percent",
    {
      attrs: {
        value: _vm.value,
        type: _vm.type,
        strokeWidth: _vm.strokeWidth,
        padding: _vm.padding,
        "text-position": _vm.type === "line" ? "right" : "auto",
        width: _vm.width,
        height: _vm.height,
        colors: [_vm.color],
      },
    },
    [
      _vm.iconClass
        ? _c("i", {
            class: _vm.iconClass,
            style: { color: _vm.color, fontSize: _vm.iconSize + "px" },
          })
        : _c("div", { style: { fontSize: _vm.iconSize + "px" } }, [
            _vm._v(" " + _vm._s(_vm._f("percent")(_vm.value)) + " "),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }